import script from "./table.vue?vue&type=script&setup=true&lang=ts"
export * from "./table.vue?vue&type=script&setup=true&lang=ts"

import "./table.vue?vue&type=style&index=0&id=397cecb8&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397cecb8"]])

export default __exports__